import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';

import Image from '../../misc/Image';
import ImageInfo from '../../misc/ImageInfo';

import { getPhotoVariant } from '../../../utils/common';
import { THUMBNAIL, RECHECK_APPROVED, RECHECK_REJECTED, RECHECK_REQUESTED, RECHECK } from '../../../utils/variables';
import { FormattedMessageWrappedInSpan } from '../../misc';

import DoneRoundedIcon from '@material-ui/icons/DoneRounded';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import RefreshRoundedIcon from '@material-ui/icons/RefreshRounded';

const MediaListItem = (props) => {
  const { item, intl, onShowPreview, listType, status } = props;
  // According to the backend team, we can't assume that the object which describes a
  // specific variant will always be found at the same index in the array.

  // if (isAccountEventPage) {
  //   const socialMedia = getPhotoVariant(item.variants, SOCIAL_MEDIA);
  //   if (socialMedia) {
  //     return socialMedia;
  //   }
  // }

  // If none of the previous variants were found return the 'thumbnail' variant
  const photoVariant = getPhotoVariant(item.variants, THUMBNAIL);

  const defineBottomLeftElement = () => {
    if (listType != RECHECK) {
      return (
        <ImageInfo
          label={intl.formatTime(new Date(item.shotDate), {
            timeZone: 'UTC',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          })}
        />
      );
    } else {
      if (status === RECHECK_REQUESTED) {
        return (
         <>
            <RefreshRoundedIcon />
            <FormattedMessageWrappedInSpan
              id="accountRecheckPage.state.progress"
              defaultMessage="In progress"
            />
          </>
        );
      }

      if (status === RECHECK_APPROVED) {
        return (
          <>
            <DoneRoundedIcon />
            <FormattedMessageWrappedInSpan
              id="accountRecheckPage.state.approved"
              defaultMessage="Approved"
            />
          </>
        );
      }

      if (status === RECHECK_REJECTED) {
        return (
          <>
            <CloseRoundedIcon />
            <FormattedMessageWrappedInSpan
              id="accountRecheckPage.state.rejected"
              defaultMessage="Rejected"
            />
          </>
        );
      }
    }
  };

  return (
    <div
      className={classNames('medialist-item-container')}
      onClick={() => onShowPreview(item.id)}
    >
      <Image
        coloredRecheckOverlay={status}
        src={photoVariant?.url || item.url}
        imgHasFullWidth={true}
        bottomLeftElement={defineBottomLeftElement()}
      />
    </div>
  );
};

MediaListItem.propTypes = {
  status: PropTypes.string,
  item: PropTypes.object,
  intl: PropTypes.object,
  onShowPreview: PropTypes.func,
  listType: PropTypes.string,
};

export { MediaListItem };

export default createFragmentContainer(injectIntl(MediaListItem), {
  item: graphql`
    fragment MediaListItem_item on Media {
      id
      sgId
      name
      shotDate
      variants {
        name
        url
      }
    }
  `,
});
